<template>
    <Dialog v-model:visible="visible" :closable="false" :modal="true"
        header="Subscription Required" class="center-dialog"
        :style="{ width: '450px', maxWidth: '90vw' }">
        <p>{{ message }}</p>
        <div class="flex justify-center gap-2 mt-4">
            <Button :label="buttonLabel" raised @click="goToCheckout" />
            <Button label="Go to Profile" class="p-button-outlined" @click="goToProfile" />
        </div>
    </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';

const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const allowedRoutes = ['checkout', 'profile'];
const visible = computed(() => userStore.subscriptionBlocked && !allowedRoutes.includes(route.name));

const message = computed(() => {
    if (userStore.subscriptionBlockReason === 'trial_expired') {
        return 'Your free trial has ended. Subscribe to keep using SmartHOA.';
    }
    return 'Your subscription has expired. Renew to keep using SmartHOA.';
});

const buttonLabel = computed(() => {
    if (userStore.subscriptionBlockReason === 'trial_expired') {
        return 'Subscribe Now';
    }
    return 'Renew Subscription';
});

const goToCheckout = () => {
    router.push({ name: 'checkout' });
};

const goToProfile = () => {
    router.push({ name: 'profile' });
};
</script>

<style scoped>
.center-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
